import Isotope from 'isotope-layout';
import 'magnific-popup';
import bridget from 'jquery-bridget';
import mediaQueryLists from '../global/mediaQueryListFactory';

bridget('isotope', Isotope, $);

/**
 * Isotope Filtering Plugin
 */
class FilterGrid {
    get done() {
        return this.pagination.page >= this.pagination.total;
    }

    constructor($grid) {
        if (!$grid.length) return;

        this.$grid = $grid;
        this.mediaQueryLists = mediaQueryLists();

        const defaults = { layoutMode: 'fitRows', percentPosition: true };
        this.settings = $.extend(true, {}, defaults, this.$grid.data('filter-grid') || {});
        this.$window = $(window);
        this.$loadingOverlay = $('[data-loading-overlay]');
        this.queryString = window.location.search.slice(1);
        this.hasCategories = $('[data-category-code]', this.$grid).length > 0;

        // items
        this.$items = $('.gallery-image');

        // Section Elements
        this.$filters = $(this.$grid.data('filterSource'));
        this.$gridItems = $(this.settings.itemSelector, this.$grid);

        // Pagination
        this.$loadMore = $('[data-load-more]');
        this.pagination = this.$loadMore.data() || {};
        this.pagination.page = 1;
        this.pagination.total = this.pagination.total || 1;
        this.pagination.itemsPerPage = this.pagination.itemsPerPage || 12;

        if (this.pagination.contentSection) $(`[id="${this.pagination.contentSection}"]`, this.$grid).remove();

        // Function Bindings
        this.onArrangeComplete = $.debounced(this.onArrangeComplete.bind(this), 100);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.onLocationPopstate = this.onLocationPopstate.bind(this);
        this.onLinkClick = this.onLinkClick.bind(this);
        this.onLoadMoreClick = this.onLoadMoreClick.bind(this);
        this.onScroll = $.debounced(this.onScroll.bind(this), 100);

        this.totalToShow = 12;

        this.init();
    }

    init() {
        this.setFiltersFromQuery();

        if (window.history) window.history.replaceState(this.$filters.serializeArray(), document.title, window.location.href);

        this.settings.filter = this.getFilterFunction(this.$filters.serializeArray());

        // Init Isotope Filtering
        this.bindEvents();
        this.$grid.isotope(this.settings);
        this.$grid.isotope('hideItemElements', this.$gridItems);

        this.updateItemData(this.$filters.serializeArray());
        this.$grid.addClass('initialized');

        setTimeout(() => {
            this.$grid.removeClass('filter-grid--loading');
        }, 600);

        if (this.pagination.itemIndex) this.showGalleryPopupByIndex(this.pagination.itemIndex, true);
    }

    bindEvents() {
        this.$grid.on('arrangeComplete', this.onArrangeComplete);
        this.$window.on('popstate', this.onLocationPopstate);
        this.$filters.on('change', this.onFilterChange);
        this.$gridItems.on('click', '[data-filter-link]', this.onLinkClick);
        this.$loadMore.on('click', this.onLoadMoreClick);
        $(window).on('scroll', this.onScroll);
    }

    unbindEvents() {
        this.$grid.off('arrangeComplete', this.onArrangeComplete);
        this.$window.off('popstate', this.onLocationPopstate);
        this.$filters.off('change', this.onFilterChange);
        this.$gridItems.off('click', '[data-filter-link]', this.onLinkClick);
        this.$loadMore.off('click', this.onLoadMoreClick);
        $(window).off('scroll', this.onScroll);
    }

    /**
     * Checks if continuous scroll should load more images
     * @param {Event} event The event object
     */
    onScroll() {}

    /**
     * Hides the loading overlay whenever isotope finishes arranging the grid items
     * @param {Event} event The event object
     */
    onArrangeComplete(event, items) {
        // console.log('items are: ', items);
        this.$loadingOverlay.hide();
        this.autosizeItems(items);
    }

    /**
     * Updates form values whenever the popstate event is triggered
     * @param {PopStateEvent} event The popstate event object
     */
    onLocationPopstate(event) {
        const formValues = event.originalEvent.state;

        if (formValues && formValues.length) {
            for (let i = 0; i < formValues.length; i++) {
                const item = formValues[i];
                const $input = $(`[name="${item.name}"]`);
                $input.val(item.value);
                $input.trigger('change', { popstate: true });
            }
        }
    }

    /**
     * Updates the content whenever filters are changed
     * @param {Event} event The event object
     */
    onFilterChange(event, data) {
        // should filter be ignored
        const ignoreFilter = $(event.target).data().filterIgnore;
        if (ignoreFilter) return;
        const allFilters = $(event.currentTarget).serializeArray();
        const selectedFilters = allFilters.filter(filter => filter.name !== 'shape');
        const filtersOffset = $('[data-filters]').offset().top;
        const resultsOffset = $('[data-results]').offset().top;
        const headerOffset = $('.t-site-header__masthead').outerHeight();
        const noScroll = data && data.noScroll || false;
        const popstate = data && data.popstate;
        const largeMediaQueryList = this.mediaQueryLists.large;
        this.$loadingOverlay.show();

        this.updateItemData(selectedFilters);

        console.log('SELETED FILTERS ARE: ', selectedFilters);

        const newUrl = window.location.origin + window.location.pathname + this.buildFilterQuery(selectedFilters) + window.location.hash;
        if (window.history && !popstate) window.history.pushState(selectedFilters, document.title, newUrl);
        if (!largeMediaQueryList.matches && !noScroll) {
            $('html, body').animate({ scrollTop: resultsOffset - headerOffset }, 300, () => { this.applyFilters(selectedFilters); });
        } else if (document.documentElement.scrollTop < filtersOffset - headerOffset && !noScroll) {
            $('html, body').animate({ scrollTop: filtersOffset - headerOffset }, 300, () => { this.applyFilters(selectedFilters); });
        } else {
            this.applyFilters(selectedFilters);
        }

        $(window).trigger('filter-selected');
    }

    onLinkClick(event) {
        const delegate = event.delegateTarget;
        const target = event.currentTarget;
        const linkType = target.dataset.filterLink;

        event.preventDefault();

        switch (linkType) {
        case 'image':
        default:
            this.showGalleryPopupByElement(delegate);
        }
    }

    autosizeItems(items) {
        const rows = {};
        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            $(item.element).height('');
            item.getSize();
            const y = item.position.y;
            const height = item.size.height;
            if (!rows[y]) {
                rows[y] = {
                    elems: [],
                    height: 0,
                };
            }

            rows[y].elems.push(item.element);
            if (rows[y].height < height) rows[y].height = height;
        }

        for (const y in rows) {
            if (Object.prototype.hasOwnProperty.call(rows, y)) {
                const row = rows[y];
                for (let i = 0; i < row.elems.length; i++) {
                    const $elem = $(row.elems[i]);
                    $elem.height(row.height);
                }
            }
        }

        this.$grid.isotope('layout');
    }

    showGalleryPopupByElement(element) {
        const index = this.$gridItems.index(element);
        this.showGalleryPopupByIndex(index);
    }

    showGalleryPopupByIndex(index, scroll = false) {
        if (index === -1) return;
        if (index > this.$gridItems.length - 1) {
            this.loadMoreByItemIndex(index).then(() => {
                if (index > this.$gridItems.length - 1) {
                    throw new Error(`No item found at index ${index}`);
                } else {
                    this.showGalleryPopupByIndex(index, scroll);
                }
            })
                .catch(console.error);
        } else {
            const gridItems = this.$gridItems.toArray();
            const $slide = $(gridItems[index]);

            let slides = gridItems.map((gridItem, i) => ({
                index: i,
                img_img: gridItem.dataset.imageSrc,
                title: gridItem.dataset.imageTitle,
                description: gridItem.dataset.imageDescription,
                tags: gridItem.dataset.imageTags.split(',').map(tag => `<span class="tag o-list-inline__item u-bg-ghost u-font-small u-text-medium">${tag}</span>`),
                visible: this.settings.filter(null, gridItem),
            }));

            slides = slides.filter(slide => slide.visible);
            const slideIndex = slides.findIndex(slide => slide.index === index);

            if (slideIndex > -1 && scroll) $('html, body').animate({ scrollTop: $slide.offset().top - (window.innerHeight - $slide.outerHeight()) / 2 }, () => this.openImagePopup(slides, slideIndex));
            else this.openImagePopup(slides, slideIndex);
        }
    }

    onLoadMoreClick(event) {
        event.preventDefault();
        // this.loadMoreInstant();
    }

    loadMore() {
        if (this.done || !this.pagination.layout || !this.pagination.contentSection) return new Promise(resolve => resolve());

        return $.get('/api.html', {
            get: 'layout',
            format: 'html',
            layout: this.pagination.layout,
            content_section: this.pagination.contentSection,
            page: this.pagination.page + 1,
            items_per_page: this.pagination.itemsPerPage,
        })
            .then(response => {
                const $items = $(response)
                    .filter((i, item) => item.nodeType === 1)
                    .not(`[id="${this.pagination.contentSection}"]`);

                this.$grid.append($items);
                this.updateItemData(this.$filters.serializeArray());
                this.$grid.isotope('appended', $items);

                this.pagination.page++;
                if (this.done) this.$loadMore.fadeOut();
            })
            .catch(error => {
                console.error('Unable to load more items', error);
            });
    }

    loadMoreByPage(page) {
        if (this.done) return new Promise(resolve => resolve());
        return this.loadMore().then(() => this.loadMoreByPage(page));
    }

    loadMoreByItemIndex(index) {
        const page = Math.ceil(index / this.pagination.itemsPerPage);
        return this.loadMoreByPage(page);
    }

    /**
     * Creates a function that can be used for filtering model results
     *
     * @param {({ name: string; value: string; })[]} formValues Array of name values pairs representing the selected filters
     * @returns {(i, elem) => boolean} The function used to filter results
     */
    getFilterFunction(formValues) {
        return (i, elem) => {
            if (!elem.filters) return false;
            const filter = formValues.every((item) => !item.value || item.value.split(', ').every((value) => elem.filters[item.name] && elem.filters[item.name].indexOf(value) > -1));
            if (this.displayCount < 12 && filter) {
                $(elem).removeClass('hide-image');
                this.displayCount++;
            }
            return filter;
        };
    }

    /**
     * Builds a query string from the selected filters that can be used to deeplink the selected filters
     *
     * @param {({ name: string; value: string; })[]} formValues Array of name values pairs representing the selected filters
     * @returns {string} The query string representation the selected filters
     */
    buildFilterQuery(formValues) {
        let query = '';

        if (formValues.length) {
            const queryArray = [];

            for (let i = 0; i < formValues.length; i++) {
                const item = formValues[i];
                const values = item.value.split(', ');

                for (let j = 0; j < values.length; j++) {
                    const value = values[j];

                    if (value) queryArray.push(`${encodeURIComponent(item.name)}=${encodeURIComponent(value)}`);
                }
            }

            if (queryArray.length) query += `?${queryArray.join('&')}`;
        }

        return query;
    }

    /**
     * Builds a hash using the selected filters to filter products on subsequent pages
     *
     * @param {({ name: string; value: string; })[]} formValues Array of name values pairs representing the selected filters
     * @returns {string} The hash to append to urls for filtering
     */
    buildFilterHash(formValues) {
        let hash = '';

        for (let i = 0; i < formValues.length; i++) {
            const item = formValues[i];
            let values = [];
            if (item.name.indexOf('f_') === 0) {
                values = item.value && item.value.split(', ') || [];
            }

            for (let j = 0; j < values.length; j++) {
                const value = values[j];
                if (value) {
                    hash += `/filter:${item.name.replace(' ', '$2520')}:${value.replace(' ', '$2520')}`;
                }
            }
        }

        if (hash) hash = `#${hash}`;

        return hash;
    }

    /**
     * Sets the filter hash on the anchor tags in a given element based on the selected filters
     *
     * @param {({ name: string; value: string; })[]} formValues Array of name values pairs representing the selected filters
     * @param {HTMLElement} elem The element containing the anchor tags to apply the hash to
     */
    updateItemUrl(elem, formValues) {
        $(elem).find('a').each((i, anchor) => {
            const href = anchor.href || '';
            const url = href.split('#').shift();
            const hash = this.buildFilterHash(formValues);
            const newHref = url + hash;
            anchor.href = newHref;
        });
    }

    /**
     * Apply filters to results
     *
     * @param {({ name: string; value: string; })[]} formValues Array of name values pairs representing the selected filters
     */
    applyFilters(formValues) {
        this.settings.filter = this.getFilterFunction(formValues);
        this.displayCount = 0;
        $('.gallery-image').addClass('hide-image');
        this.$grid.isotope({
            filter: this.settings.filter,
        });
    }

    /**
     * Fetch SearchSpring Products
     *
     * @param {string} category The code of the category to pull products from
     * @param {({ [key: string]: string; })} filters The filters to use when querying products
     * @param {Function} callback An optional callback function that will be called after the request chain is complete
     * @returns {Promise<any[]>} Promise that resolves to an array of products
     */
    makeSSRequest(category, filters, callback) {
        this.requestQuery = {
            siteId: 'qewnm8',
            userId: '96B5AEE7-98AB-434B-8C51-520BA2B611CA',
            resultsFormat: 'native',
            resultLayout: 'list',
            'bgfilter.cc': category,
            resultsPerPage: 50,
        };

        if (filters) {
            for (const filter in filters) {
                if (Object.prototype.hasOwnProperty.call(filters, filter)) {
                    this.requestQuery[`filter.${filter}`] = filters[filter];
                }
            }
        } else if (!callback) {
            callback = filters;
        }

        const request = this.recursiveRequestLoop();

        if (typeof callback === 'function') request.then(callback).catch(callback);
        return request;
    }

    /**
     * Recursive function to retrieve every product
     *
     * @param {any[]} results
     * @param {number} page
     * @returns {Promise<any[]>} Promise for the request chain
     */
    recursiveRequestLoop(results, page) {
        if (!results) results = [];
        if (page) this.requestQuery.page = page;
        return $.get('https://api.searchspring.net/api/search/search.json', this.requestQuery)
            .then((res) => {
                results = results.concat(res.results);

                if (res.pagination.currentPage < res.pagination.totalPages) {
                    return this.recursiveRequestLoop(results, res.pagination.currentPage + 1);
                }
                return results;
            });
    }

    /**
     * Sets the filter data from the data-filter-item attribute of a given element
     *
     * @param {HTMLElement} elem The element containing the data-filter-item attribute
     */
    setupFilterData(elem) {
        elem.filters = {};
        const arr = elem.dataset.filterItem && elem.dataset.filterItem.split(',');

        for (let i = 0; i < arr.length; i++) {
            const item = arr[i];
            const name = item.split(':')[0];
            const value = item.split(':')[1];
            elem.filters[name] = elem.filters[name] || [];
            elem.filters[name].push(value);
        }
    }

    /**
     * Updates the price text
     *
     * @param {HTMLElement} elem The element to set the price for
     * @param {string|boolean} override Overrides the listed price. If the value is a string, its value will be used. If the value is true, the fallback text will be used
     */

    updatePriceTag(elem, override) {
        const $item = $(elem);
        const $price = $item.find('.card-price');
        let priceText = 'Select to View Price';
        let price = '';
        // const oldPrice = $price.text();

        if (!$price.length) return;

        if (override && typeof override === 'string') priceText = override;
        if (!override && elem.matchedProducts) {
            for (let i = 0; i < elem.matchedProducts.length; i++) {
                const product = elem.matchedProducts[i];
                if (product.price) {
                    if (price === '') price = parseFloat(product.price);
                    if (product.price < price) price = parseFloat(product.price);
                }
            }

            if (price) priceText = `Price Starting At: $${price}`;
        }

        $item.attr('data-price', price);
        $price.text(priceText);
    }

    /**
     * Sets the value of the matchedProducts property for a given element
     *
     * @param {HTMLElement} elem The element to store matched products in
     * @param {({ name: string; value: string; })[]} formValues Array of name values pairs representing the selected filters
     */
    filterProductData(elem, formValues) {
        if (!elem.products) return;
        elem.matchedProducts = [].concat(elem.products);

        for (let i = 0; i < formValues.length; i++) {
            const field = formValues[i];

            if (field.name.indexOf('f_') !== 0 || field.value === '') continue;

            for (let j = elem.matchedProducts.length - 1; j > -1; j--) {
                const product = elem.matchedProducts[j];
                const ssField = product[field.name];

                if (ssField && ssField.toLowerCase() !== field.value.toLowerCase()) elem.matchedProducts.splice(j, 1);
            }
        }
    }

    /**
     * Fetches the product data for a specified element
     *
     * @param {HTMLElement} elem The element to store the product data in
     * @returns {Promise<any[]>} A promise that resolves to the matched set of products
     */
    fetchProductData(elem) {
        this.updatePriceTag(elem, 'Loading Price\u2026');

        return this.makeSSRequest(elem.dataset.categoryCode)
            .then(results => {
                elem.products = results;
                return results;
            })
            .catch(error => {
                console.error(error);
                this.updatePriceTag(elem, true);
            });
    }

    updateSortData() {
        this.$grid.isotope('updateSortData').isotope();
    }

    /**
     * Updates the product, filter, and pricing data for each item
     *
     * @param {({ name: string; value: string; })[]} formValues Array of name values pairs representing the selected filters
     */
    updateItemData(formValues) {
        this.unbindEvents();

        this.$gridItems = $(this.settings.itemSelector, this.$grid);
        this.$gridItems.each((i, elem) => {
            if (!elem.filters) this.setupFilterData(elem);

            this.updateItemUrl(elem, formValues);

            if (!elem.products && this.hasCategories) {
                this.fetchProductData(elem)
                    .then(() => {
                        this.filterProductData(elem, formValues);
                        this.updatePriceTag(elem);
                        this.updateSortData();
                    });
            } else {
                this.filterProductData(elem, formValues);
                this.updatePriceTag(elem);
                this.updateSortData();
            }
        });

        this.bindEvents();
    }

    /**
     * Sets the default values of filters from the query parameters specified in the current url
     */
    setFiltersFromQuery() {
        const query = window.buildQueryObjects().object;

        // Set default form field values
        for (const name in query) {
            if (Object.prototype.hasOwnProperty.call(query, name)) {
                const value = query[name];
                $(`[name="${name}"]`, this.$filters).val(value.join(', '));
            }
        }

        $(document).trigger('updateToggleButtonInstances');
    }

    openImagePopup(items, index) {
        $.magnificPopup.open({
            key: 'image-gallery',
            items,
            type: 'inline',
            mainClass: 'image-gallery-container',
            inline: {
                markup: `
                    <div class="mfp-figure">
                        <div class="mfp-close"></div>
                        <figure class="o-layout o-layout--flush">
                            <div class="mfp-figure-image o-layout__item u-width-8--l u-width-7--m u-width-12">
                                <div class="mfp-img"></div>
                            </div>
                            <figcaption class="o-layout__item u-width-4--l u-width-5--m u-width-12">
                                <div class="mfp-right-sidebar">
                                    <div class="mfp-title"></div>
                                    <div class="mfp-description"></div>
                                    <div class="mfp-tags tags u-flex o-list-inline o-list-inline--narrow u-font-small"></div>
                                    <div class="mfp-share u-flex o-layout--wrap u-margin-top"></div>
                                    <div class="mfp-counter"></div>
                                </div>
                            </figcaption>
                        </figure>
                    </div>
                `,
            },
            gallery: {
                enabled: true,
            },
            callbacks: {
                open: () => {
                    const instance = $.magnificPopup.instance;
                    if (typeof index === 'number' && index > -1) setTimeout(() => instance.goTo(index), 0);
                },
                change: () => {
                    // After Image Load / Change
                    const instance = $.magnificPopup.instance;
                    const $share = instance.content.find('.mfp-share');
                    const shareElem = $share.get(0);
                    const shareUrl = `${window.location.origin}${window.location.pathname}?item_index=${instance.index}`;
                    const baseElem = document.head.querySelector('base');
                    const baseURI = baseElem.href || window.location.origin;

                    instance.contentContainer.addClass('o-wrapper o-wrapper--small o-wrapper--flush');

                    $share.empty();
                    $share.append(
                        `<div class="fb-share-button"
                            data-href="${window.location.origin + window.location.pathname}?item_index=${instance.index}"
                            data-layout="button"
                            data-size="large"
                            data-mobile-iframe="true">
                            <a target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}&src=sdkpreparse" class="fb-xfbml-parse-ignore">Share</a>
                        </div>`,
                    );

                    $share.append(
                        `<a class="twitter-share-button"
                            href="https://twitter.com/intent/tweet?text=${instance.currItem.data.title}&url=${encodeURIComponent(shareUrl)}&via=royalswimming"
                            data-size="large">
                            Tweet
                        </a>`,
                    );

                    $share.append(
                        `<a data-pin-do="buttonPin"
                            data-pin-tall="true"
                            href="https://www.pinterest.com/pin/create/button/?url=${encodeURIComponent(shareUrl)}&media=${encodeURIComponent(baseURI + instance.currItem.data.img_img)}&description=${encodeURIComponent(instance.currItem.data.title)}">
                        </a>`,
                    );

                    if (window.PinUtils) window.PinUtils.build(shareElem);

                    setTimeout(() => {
                        if (window.FB) window.FB.XFBML.parse();
                        if (window.twttr) window.twttr.widgets.load();
                    });
                },
            },
        });
    }
}

export default () => {
    const $filterGrid = $('[data-filter-grid]');

    if ($filterGrid.length) {
        const instances = window.filterGrids = [];

        $filterGrid.each((i, grid) => {
            const $grid = $(grid);

            setTimeout(() => {
                instances.push(new FilterGrid($grid));
            }, 300);
        });
    }
};
